<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>계약</li>
        <li>청약 입력/조회 및 증권출력</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>청약 결과 조회</h2>
        <div class="depLink">
          <button type="button" title="메뉴">
            <span>청약 입력/조회 및 증권출력</span>
          </button>
          <ul>
            <li>
              <router-link to="/contactpoint"><span>알아두실 사항</span></router-link>
            </li>
            <li>
              <router-link to="/sbcpInpInqNdPolOtpt"><span>청약 입력/조회 및 증권출력</span></router-link>
            </li>
            <li>
              <router-link to="/subsChangeForm"><span>증권 간략 정정</span></router-link>
            </li>
            <li>
              <router-link to="/unpaidList"><span>미납조회</span></router-link>
            </li>
            <li>
              <router-link to="/staMon"><span>계약 통계</span></router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="tabBtn">
          <router-link to="/sbcpInpInqNdPolOtpt"
            ><span>청약 입력</span></router-link
          >
          <a class="active"><span>청약 결과 조회</span></a>
          <router-link to="/getPolList"
            ><span>계약 조회 및 증권 출력</span></router-link
          >
        </div>

        <div class="sortWrap type2">
          <dl>
            <dt class="w72">접수일자</dt>
            <dd>
              <div class="split">
                <div class="form_input_area type_calendar" style="width: 47%">
                  <datepicker
                    v-model="state.dateInfo.inpStDt"
                    :locale="ko"
                    class="form_input"
                    inputFormat="yyyy-MM-dd"
                    typeable
                    ref="startDate"
                    @input="inputDate"
                    maxlength="10"
                  />
                  <button type="button" class="btn_calendar" @click="openCalendar('startDate')" @blur="closeCalendar('startDate')">
                    <span>날짜선택</span>
                  </button>
                </div>
                <span style="margin: 13px 0px 0px 10px">~</span>
                <div class="form_input_area type_calendar" style="width: 46%">
                  <datepicker
                    v-model="state.dateInfo.inpEdDt"
                    :locale="ko"
                    class="form_input"
                    typeable
                    ref="endDate"
                    @input="inputDate"
                    maxlength="10"
                  />
                  <button type="button" class="btn_calendar"  @click="openCalendar('endDate')" @blur="closeCalendar('endDate')">
                    <span>날짜선택</span>
                  </button>
                </div>
                <div class="inpSlt">
                  <button type="button" class="sltBtn" title="조건 선택">
                    <span>전체</span>
                  </button>
                  <ul>
                    <li>
                      <button type="button" class="sltOpt" title="선택">
                        <span>전체</span>
                      </button>
                    </li>
                    <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                    <li>
                      <button type="button" class="sltOpt">
                        <span>{{ logId }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </dd>
          </dl>
          <button type="button" class="btnSearch" @click="fnSearch(true)">
            <span class="hide">검색</span>
          </button>
        </div>

        <h3 class="conTit">조회결과</h3>
        <div class="tabStyle2">
          <table>
            <caption>
              조회결과
            </caption>
            <colgroup>
              <col width="*" />
              <col width="240" />
              <col width="240" />
              <col width="240" />
              <col width="240" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" height="62">(가)계약번호</th>
                <th scope="col">참고번호</th>
                <th scope="col">입력일</th>
                <th scope="col">증권번호</th>
                <th scope="col">상태</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in state.cargInetPrctrLstInfBcVo"
                :key="index"
              >
                <td height="74">
                  <a @click="move(item.prctrNo, item.prctrStatCd)"> {{ item.prctrNo }}</a>
                </td>
                <td>{{ item.refnNo }}</td>
                <td>{{ item.inpDt }}</td>
                <td>{{ item.polNo }}</td>
                <td>{{ item.prctrStatNm }}</td>
              </tr>

              <tr v-if="state.cargInetPrctrLstInfBcVo.length == 0">
                <td colspan="5">
                  <p class="noData">조회된 결과가 없습니다.</p>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 더보기 없을떄 삭제 영역 [s] -->
          <button
            type="button"
            class="btnMore"
            v-if="isActiveBtnMore()"
            @click="fnSearch()"
          >
            <span>더보기</span>
          </button>
          <!-- 더보기 없을떄 삭제 영역 [e] -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import { format, subDays } from "date-fns";
import Datepicker from "vue3-datepicker";

const axios = inject("axios");
const router = useRouter();
const swalAlert = inject("swalAlert");

let logId = ref(null);
let pageNum = ref(1);
let totalrRptPrem = ref(0);
let startDate = ref(null);
let endDate = ref(null);

let now = new Date();


const openCalendar = (tp) => {
  switch(tp) {
    case "startDate":
      startDate.value.renderView('day')
      break;
    case "endDate":
      endDate.value.renderView('day')
      break;
  }
  
}

const closeCalendar = (tp) => {
  switch(tp) {
    case "startDate":
      startDate.value.renderView('none')
      break;
    case "endDate":
      endDate.value.renderView('none')
      break;
  }
}

//선택 증번 이동
const move = (prctrNo, prctrStatCd) => {
  //조회출력로그인시청약입력 페이지 접속
  let moveTypeCd = 'Y'
  sessionUserInfo.userInfo.moveTypeCd = moveTypeCd;
  
  router.push({ name: "sbcpInpInqNdPolOtpt", query: { prctrNo: prctrNo , prctrStatCd : prctrStatCd } });
};

//진입시 검색 기간 1달
const state = reactive({
  cargInetPrctrLstInfBcVo: [],
  currDateFormatEd: util.formatDate(new Date(), "yyyy-mm-dd"),
  currDateFormatSt: util.formatDate(
    new Date(now.setDate(now.getDate() - 7)),
    "yyyy-mm-dd"
  ),
  dateInfo: {},
  totalrRptPrem : "",
  pstmPg : "1",
});

//더보기
const isActiveBtnMore = () => {
  return (
    state.cargInetPrctrLstInfBcVo.length != 0 &&
    state.totalrRptPrem >= 31 &&
    state.totalrRptPrem / 30 > state.pstmPg
  );
};

//검색
const fnSearch = async (reset) => {
  if (reset) {
    state.cargInetPrctrLstInfBcVo = [];
    state.pstmPg = 1;
  } else state.pstmPg = state.pstmPg + 1;

  //조회 기간 확인
  if (
    util.formatDate(state.dateInfo.inpStDt, "yyyymmdd") >
    util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd")
  ) {
    swalAlert("조회기간을 확인해 주세요.");
    return;
  } else if (
    util.getDay(
      util.formatDate(state.dateInfo.inpStDt, "yyyymmdd"),
      util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd")
    ) > 8
  ) {
    swalAlert("검색기간은 8일 까지 가능합니다.");
    return;
  }

  let voMap = {};

  voMap.inqStdt = util.formatDate(state.dateInfo.inpStDt, "yyyymmdd");
  voMap.inqEdt = util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd");
  voMap.inppeId = "";
  voMap.polhdId = sessionUserInfo.slzCusInf.cusNo; // 고객번호 (cusNo);  "10001326596"
  voMap.pstmPg = state.pstmPg;
  console.log("voMap", voMap);
  var result = await axios.transaction("FNGCTNFO0194", voMap);
  if (_.isEmpty(result.body?.cargInetPrctrLstInfBcVo)) return;
  state.totalrRptPrem = result.body.ttCnt; //조회 총 개수

  state.cargInetPrctrLstInfBcVo = state.cargInetPrctrLstInfBcVo.concat(
      _.flatten([result.body?.cargInetPrctrLstInfBcVo || result.body])
  );

  // if (_.isArray(result.body.cargInetPrctrLstInfBcVo)) {
  //   state.cargInetPrctrLstInfBcVo = result.body.cargInetPrctrLstInfBcVo;
  // } else {
  //   state.cargInetPrctrLstInfBcVo.push(result.body.cargInetPrctrLstInfBcVo);
  // }
};

init();

//페이지 진입시
async function init() {
  await load();
  console.log("로그인 정보값", sessionUserInfo);
  logId.value = sessionUserInfo.logId;
  state.dateInfo.inpStDt = new Date(state.currDateFormatSt);
  state.dateInfo.inpEdDt = new Date(state.currDateFormatEd);
  fnSearch(true);
  axios.json('/logHisLdg.do', {memo:"청약결과조회" ,page:window.location.hash});
}
</script>

<style></style>
